var map = {
  "./modules/admin/nodemenu": "90208",
  "./modules/glossary/nodemenu": "16757",
  "./modules/gndo/nodemenu": "29757",
  "./modules/mods/nodemenu": "47142"
};


function __rspack_async_context(req) {
  return __rspack_async_context_resolve(req).then(__webpack_require__);
}
function __rspack_async_context_resolve(req) {
  return Promise.all(/* lazy-once context | core */ [__webpack_require__.e("rbush-node_modules_rbush_rbush_min_js"), __webpack_require__.e("vendors-node_modules_date-fns_esm_differenceInYears_index_js-node_modules_date-fns_esm_getDat-803fb0"), __webpack_require__.e("src_modules_serverlog_utils_js-src_tree_rules_js-src_viewer_layouts_js"), __webpack_require__.e("core")]).then(function() {
    if(!__webpack_require__.o(map, req)) {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    }
    return map[req];
  })
}
__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.resolve = __rspack_async_context_resolve;
__rspack_async_context.id = 70921;
module.exports = __rspack_async_context;
